import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import * as base64 from 'base-64';
import * as utf8 from 'utf8';
import { Boleto } from '../models/Boleto';
import { LocalstorageService } from '../services/localstorage.service';
import { SessionstorageService } from '../services/sessionstorage.service';
import { TimerService } from '../timer/timer.service';
import { BoletosColaboradoresService } from './services/boletos-colaboradores.service';
import { environment } from 'src/environments/environment';
import { SessionstorageDosService } from 'src/service/sessionstorage-dos.service';
import { VentaDigitalExternaComponent } from '../venta-digital-externa/venta-digital-externa.component';
import { MetodosLigaColaborador } from '../services/metodos-liga-colaborador';

@Component({
  selector: 'app-boletos-colaboradores',
  templateUrl: './boletos-colaboradores.component.html',
  styleUrls: ['./boletos-colaboradores.component.scss'],
})
export class BoletosColaboradoresComponent implements OnInit {
  public clave_colaborador: number = 0;
  public clave_colaborador_encoded: string;
  public nombre_colaborador: string;
  public boletos_recomendados: Array<Boleto> = [];
  public boletos_colaborador: Array<Boleto> = [];
  public total_compra: number = 0;
  public tipos_pago: number = 1;

  constructor(
    private _session: SessionstorageService,
    private _local: LocalstorageService,
    private _BColaboradoresService: BoletosColaboradoresService,
    private route: ActivatedRoute,
    private router: Router,
    public st: TimerService,
    private _sessionDos: SessionstorageDosService,
  ) {
    this.route.params.subscribe((params) => (this.clave_colaborador_encoded = params.id));
    var lsRecomendados = this._local.getBoletosRecomendados();
    this.boletos_recomendados = lsRecomendados == null ? [] : JSON.parse(lsRecomendados);
  }

  ngOnInit() {
    let clave = this.clave_colaborador_encoded;
    //////console.log(atob(clave));
    if (atob(clave) == "65960") {
      this.router.navigate(['/boletos-colaborador-anahuac-online/NjU5NjA']);
    }
    var decodedString = base64.decode(decodeURIComponent(this.clave_colaborador_encoded));
    var bytesString = utf8.decode(decodedString);
    this.clave_colaborador = Number(bytesString);

    // Venta digital externa (plazas/tiendas): misma liga, otro diseño. La lista de PK1 vive
    // en environment.ventaDigitalExterna. replaceUrl para que "atras" no rebote aqui.
    if (VentaDigitalExternaComponent.esVentaExterna(this.clave_colaborador)) {
      this.router.navigate(['venta-digital-externa', this.clave_colaborador_encoded], { replaceUrl: true });
      return;
    }
    //////console.log(this.clave_colaborador);
    this.getBoletosColaborador(this.clave_colaborador);
  }

  getBoletosColaborador(clave_colaborador: number) {
    //////console.log("Entra getBoletos");
    this._BColaboradoresService.getBoletosColaborador(clave_colaborador).subscribe(
      (data) => {
        this.boletos_colaborador = data;
        this.separarBoletosEnEspera();
        sessionStorage.setItem('liga_compartida_colaborador', environment.urlCompartirBoletos + this.clave_colaborador_encoded);
        
        console.log(this.clave_colaborador);
        //lamamos a la otra api 

        this._BColaboradoresService.UpdateBitacora(this.clave_colaborador).subscribe(
          (data) => {
            console.log(data);
          },
          (
            err //console.error(err)
          ) => { },
          () =>
          //////console.log('done loading boletos')
          { }
        );

        this._sessionDos.actualizarEstadoBloqueo();
      },
      (err) => console.error(err),
      () =>
      //////console.log('done loading boletos')
      { }
    );

    this._BColaboradoresService.getNombreColaborador(clave_colaborador).subscribe(
      (data) => {
        this.nombre_colaborador = data;
        sessionStorage.setItem('liga_compartida_nombre_colaborador', this.nombre_colaborador);
        this._sessionDos.actualizarEstadoBloqueo();
      },
      (
        err //console.error(err)
      ) => { },
      () =>
      //////console.log('done loading boletos')
      { }
    );
  }

  // Estado de la validación previa a carrito
  public validandoBoletos: boolean = false;
  public mostrarMensajeSeleccion: boolean = false;
  public mostrarModalNoDisponibles: boolean = false;
  /** Un renglón por boleto rechazado, ya partido en trozos (folio y hora en negrita). */
  public mensajesNoDisponibles: Array<Array<{ t: string; b: boolean }>> = [];

  /**
   * Boletos del colaborador que HOY no se pueden vender porque traen un pago sin
   * resolver (tarjeta en revisión, referencia vigente, etc.). Se muestran en su propia
   * sección, visibles pero NO seleccionables, con el motivo y la hora en que se liberan.
   *
   * POR QUE SE MUESTRAN EN VEZ DE ESCONDERLOS:
   * al colaborador se le asignan N boletos y los ve también en su app. Si aquí
   * desapareciera uno, preguntaría "en mi app está y en la liga no, ¿por qué?" — y quien
   * atiende no tiene por qué saberse las reglas de bloqueo. Enseñarlos con su motivo
   * contesta la pregunta ANTES de que la hagan, sin depender de que alguien se acuerde.
   */
  public boletosEnEspera: Array<{ folio: string; partes: Array<{ t: string; b: boolean }> }> = [];
  public revisandoDisponibilidad: boolean = false;
  public mostrarModalError: boolean = false;

  add(boletos_colaborador: Array<Boleto>) {
    const seleccionados = boletos_colaborador.filter((b) => b.seleccionado);

    // Sin selección: pedir amablemente que elijan al menos un boleto
    if (seleccionados.length === 0) {
      this.mostrarMensajeSeleccion = true;
      return;
    }
    this.mostrarMensajeSeleccion = false;

    // Validar en el backend que los folios sigan disponibles (estado 'N' y sin carrito)
    // antes de moverlos al carrito. Alguien más pudo haberlos apartado/comprado.
    const folios = seleccionados.map((b) => b.folio.toString()).join(',');

    this.validandoBoletos = true;

    // Se usa el MISMO validador que venta digital (api/Boleto/ValidarFoliosReferencia).
    // Las reglas de bloqueo por metodo de pago ya eran identicas en los dos validadores;
    // lo que este agrega es el MOTIVO y el MENSAJE listo para mostrar, con la hora de
    // liberacion incluida. Antes se usaba ValidarFolios, que solo devolvia true/false y
    // por eso el comprador veia un rechazo generico, sin saber por que ni hasta cuando.
    //
    // idCarrito va VACIO a proposito: esta validacion corre ANTES de apartar los boletos,
    // asi que este usuario todavia no tiene carrito. Con el vacio, el backend bloquea si
    // el boleto esta en el carrito de CUALQUIERA — la misma estrictez que daba
    // ValidarFolios con su 'carrito_libre'. (En el carrito de venta digital si se manda,
    // porque ahi corre DESPUES de apartar y sin el se bloquearia a si mismo.)
    //
    // Respuesta: [{ folio, valido, motivo, mensaje }]
    // motivo: OK | VENDIDO | PAGADO | EN_CARRITO | TARJETA | PAYPAL | REFERENCIA | OXXO |
    //         SPEI | LIGA | NO_DIGITAL | NO_EXISTE
    this._BColaboradoresService.validarBoletosODC({ folios, idCarrito: '' }).subscribe(
      (resultado: Array<{ folio: string; valido: boolean; motivo: string; mensaje: string }>) => {
        this.validandoBoletos = false;

        const invalidos = (resultado || []).filter((r) => !r.valido);

        if (invalidos.length === 0) {
          this.continuarAlCarrito(seleccionados);
        } else {
          // Un renglón por boleto, con su motivo real y el folio en negrita.
          this.mensajesNoDisponibles = invalidos.map((r) =>
            this.trocear(
              r.mensaje || `El boleto ${r.folio} no está disponible.`,
              r.folio
            )
          );
          this.mostrarModalNoDisponibles = true;
          this.refrescarListaBoletos();
        }
      },
      (err) => {
        this.validandoBoletos = false;
        this.mostrarModalError = true;
      }
    );
  }

  // Mueve los boletos seleccionados (ya validados) al carrito y navega
  private continuarAlCarrito(seleccionados: Array<Boleto>) {
    for (const boleto of seleccionados) {
      const yaAgregado = this.boletos_recomendados.some(
        (r) => r.folio === boleto.folio
      );
      if (!yaAgregado) {
        this.boletos_recomendados.push(boleto);
        this.total_compra = this.total_compra + boleto.costo;
      }
    }

    const date = new Date();
    this._local.setFechaInicio(date);
    this._local.setFechaFin(date);
    this._local.setBoletosRecomendados(this.boletos_recomendados);
    // Estos boletos pasaron por la liga: forma-pago aplica environment.metodosPagoLigaColaborador.
    MetodosLigaColaborador.marcar(seleccionados);
    this.st.startTimer();
    this._session.setBoletosCol(1);
    this._session.setTiposPago(this.tipos_pago);

    // OJO: aqui NO se pone 'pk_boleto_app'. Esa bandera significa "viene de la APP"
    // (la ponen las rutas pagar/... en pagar.component) y su unico efecto es APAGAR la
    // validacion del carrito.
    //
    // La liga de colaborador la ponia por error. Consecuencias que tenia:
    //   1. La liga se saltaba la validacion del carrito y la cancelacion del intento
    //      previo de Stripe, que si le corresponden.
    //   2. Peor: la bandera NO la borra nadie (solo un sessionStorage.clear() al final
    //      del flujo). Asi que si alguien abria una liga, no compraba, y en la misma
    //      pestaña se iba al home, su compra de VENTA DIGITAL tambien se saltaba la
    //      validacion, arrastrando una bandera que ya no le correspondia.
    //
    // Venta digital y liga de colaborador SI validan. Solo la App no.
    sessionStorage.setItem('pagina', 'Liga colaborador');
    sessionStorage.setItem('tipoBoleto', 'Boleto desde micrositio liga colaborador');
    sessionStorage.setItem('texto', 'Gracias por sumarte a Sorteo Anáhuac, con tu boleto ayudaras a muchos estudiantes');
    this.router.navigate(['carrito-compra']);
  }

  // Recarga solo la lista de boletos disponibles del colaborador (sin re-registrar bitácora).
  // Al re-consultar, los boletos ya apartados/vendidos desaparecen porque el backend
  // solo devuelve los que están en estado 'N' y sin carrito.
  /**
   * Pregunta por TODOS los folios de la lista de una sola llamada y separa los que traen
   * un pago sin resolver a la sección "en espera".
   *
   * Se usa el MISMO validador que la selección y que venta digital, a propósito: la lista
   * del colaborador (api/BoletosColaborador) solo filtra por estado 'N', digital y sin
   * carrito — NO mira ORDENDECOMPRA. Por eso entregaba boletos con un pago en proceso y el
   * comprador se topaba con el rechazo hasta después de elegirlos.
   *
   * Meterle el filtro de órdenes a esa consulta habría sido una TERCERA copia de las
   * reglas de bloqueo. Así la autoridad sigue en un solo lugar: si mañana cambian las 24 h
   * de MIT, esta lista se ajusta sola.
   */
  private separarBoletosEnEspera() {
    this.boletosEnEspera = [];

    const folios = (this.boletos_colaborador || [])
      .map((b: any) => (b.folio || '').toString().trim())
      .filter((f: string) => f.length > 0);

    if (folios.length === 0) return;

    this.revisandoDisponibilidad = true;

    // idCarrito vacío: aquí nadie ha apartado nada todavía.
    this._BColaboradoresService.validarBoletosODC({ folios: folios.join(','), idCarrito: '' }).subscribe(
      (resultado: Array<{ folio: string; valido: boolean; motivo: string; mensaje: string }>) => {
        this.revisandoDisponibilidad = false;

        const bloqueados = new Map<string, string>();
        (resultado || []).forEach((r) => {
          if (!r.valido) bloqueados.set(r.folio.toString().trim(), r.mensaje || '');
        });

        if (bloqueados.size === 0) return;

        this.boletosEnEspera = [];
        this.boletos_colaborador = (this.boletos_colaborador || []).filter((b: any) => {
          const f = (b.folio || '').toString().trim();
          if (!bloqueados.has(f)) return true;

          const texto = bloqueados.get(f) || `El boleto ${f} tiene un pago sin resolver.`;
          // El folio ya se pinta como chip al lado, asi que se le quita al mensaje para
          // no leerlo dos veces. Y se trocea con folio vacio: aqui solo va la HORA en negrita.
          this.boletosEnEspera.push({ folio: f, partes: this.trocear(this.sinPrefijoBoleto(texto, f), '') });
          return false;
        });
      },
      () => {
        // Si la revisión falla NO se esconde nada: se deja la lista completa y la
        // validación de la selección (con su modal) sigue siendo la red de seguridad.
        this.revisandoDisponibilidad = false;
      }
    );
  }

  private refrescarListaBoletos() {
    this._BColaboradoresService.getBoletosColaborador(this.clave_colaborador).subscribe(
      (data) => {
        this.boletos_colaborador = data;
        this.separarBoletosEnEspera();
      },
      (err) => console.error(err)
    );
  }

  /**
   * Parte el mensaje en trozos y marca cuáles van en negrita: el FOLIO y la HORA/FECHA
   * de liberación. Son los dos datos que la persona busca cuando lee esto, y en un
   * párrafo corrido se pierden.
   *
   * Los formatos de tiempo los arma CuandoSeLibera() en el backend, y son tres:
   *   "hoy a las 8:46 pm"   ·   "mañana a las 5:30 pm"   ·   "el 30 de agosto"
   * Si el texto no trae ninguno (o cambia de formato), simplemente no se resalta:
   * el mensaje se sigue leyendo completo.
   */
  /**
   * Quita el "El boleto 136671 " del inicio del mensaje, porque en la seccion de espera
   * el folio ya se muestra como chip a la izquierda y leerlo dos veces se ve descuidado.
   * Deja la frase empezando en mayuscula. Si el mensaje no trae ese prefijo, no lo toca.
   */
  private sinPrefijoBoleto(texto: string, folio: string): string {
    const re = new RegExp('^\\s*el\\s+boleto\\s+' + folio + '\\s*', 'i');
    const limpio = texto.replace(re, '');
    if (limpio === texto || limpio.length === 0) return texto;
    return limpio.charAt(0).toUpperCase() + limpio.slice(1);
  }

  private trocear(texto: string, folio: string): Array<{ t: string; b: boolean }> {
    const escapar = (x: string) => x.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

    const alternativas: string[] = [];
    if (folio) alternativas.push(escapar(folio));
    // Las alternativas con punto van PRIMERO: si "pm" fuera antes, "p.m." casaría a medias.
    // Y el punto no es opcional al final, para no comerse el punto de la oración.
    alternativas.push('(?:hoy|mañana) a las \\d{1,2}:\\d{2}\\s*(?:a\\.m\\.|p\\.m\\.|am|pm)');
    alternativas.push('el \\d{1,2} de [a-záéíóú]+');

    const re = new RegExp('(' + alternativas.join('|') + ')', 'gi');

    const trozos: Array<{ t: string; b: boolean }> = [];
    let cursor = 0;
    let m: RegExpExecArray | null;

    while ((m = re.exec(texto)) !== null) {
      if (m.index > cursor) trozos.push({ t: texto.substring(cursor, m.index), b: false });
      trozos.push({ t: m[0], b: true });
      cursor = m.index + m[0].length;
    }
    if (cursor < texto.length) trozos.push({ t: texto.substring(cursor), b: false });

    return trozos.length ? trozos : [{ t: texto, b: false }];
  }

  public cerrarModalNoDisponibles() {
    this.mostrarModalNoDisponibles = false;
    this.mensajesNoDisponibles = [];
  }

  public cerrarModalError() {
    this.mostrarModalError = false;
  }
}
